unit ZgodovinaLokacija;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Web, System.Dateutils, Vcl.Graphics, Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Controls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Forms,
  XData.Web.Connection, Vcl.Grids, WEBLib.Buttons, WEBLib.WebCtrls, TerminalForm;

type
  TfrmZgodovinaLokacija = class(TTerminalForm)
    tmrFind: TTimer;
    dsOdvoz: TDataSource;
    panFooter: TPanel;
    gridView: TDBGrid;
    wdsOdvoz: TXDataWebDataSet;
    lblTitle: TLabel;
    btnSelect: TButton;
    wdsOdvozOdvozCasOdvoza: TDateTimeField;
    wdsOdvozPosodaOpis: TStringField;
    wdsOdvozKolicina: TFloatField;
    procedure tmrFindTimer(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);  // Klic pride iz frmMain
  private
    { Private declarations }
    datToday: string;
    datFrom: string;

    procedure ApplyTheme; reintroduce;
  public
    { Public declarations }
    LokacijaId: integer;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses Client.Core, Main, Client.Settings, Client.Constants;

procedure TfrmZgodovinaLokacija.ApplyTheme;
begin
  inherited;

end;

procedure TfrmZgodovinaLokacija.btnSelectClick(Sender: TObject);
begin
  inherited;
  frmMain.ShowOdvoz;
end;

procedure TfrmZgodovinaLokacija.tmrFindTimer(Sender: TObject);
var Flt, Srt, Qry, datMonth: string;
begin
  tmrFind.Enabled := false;

  datMonth := DateToStr(IncDay(modMain.ZgodovinaDatum, -31), Fmt);

  Flt := Flt + 'odvoz/vozilo/id eq '+modMain.VoziloId.ToString+' and odvoz/lokacija/id eq '+LokacijaId.ToString+' and kolicina ne 0 and posoda/frakcija/id eq '+modMain.FrakcijaId.ToString+' and odvoz/casodvoza gt '+datMonth; //+'&$expand=odvoz,odvoz/lokacija';

  Srt := 'odvoz/casodvoza desc';
  Qry := '$filter='+Flt+'&$orderby='+Srt+'&$expand=odvoz,odvoz/lokacija,posoda&$top=30';

  Log('Qry='+Qry);

  wdsOdvoz.Close;
  wdsOdvoz.QueryString := Qry;
  wdsOdvoz.Load;

//  ToggleButtons;
end;

procedure TfrmZgodovinaLokacija.WebFormCreate(Sender: TObject);
begin
  inherited;

  datToday := DateToStr(modMain.ZgodovinaDatum, Fmt);
  datFrom := DateToStr(IncDay(modMain.ZgodovinaDatum, -60), Fmt);

  ApplyTheme;
end;

procedure TfrmZgodovinaLokacija.WebFormShow(Sender: TObject);
begin
  inherited;

  gridView.ColWidths[0] := Round(frmMain.Width * 0.4)-10;
  gridView.ColWidths[1] := Round(frmMain.Width * 0.5)-10;
  gridView.ColWidths[2] := Round(frmMain.Width * 0.1)-10;
end;

procedure TfrmZgodovinaLokacija.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblTitle := TLabel.Create(Self);
  panFooter := TPanel.Create(Self);
  btnSelect := TButton.Create(Self);
  gridView := TDBGrid.Create(Self);
  tmrFind := TTimer.Create(Self);
  dsOdvoz := TDataSource.Create(Self);
  wdsOdvoz := TXDataWebDataSet.Create(Self);
  wdsOdvozOdvozCasOdvoza := TDateTimeField.Create(Self);
  wdsOdvozPosodaOpis := TStringField.Create(Self);
  wdsOdvozKolicina := TFloatField.Create(Self);

  lblTitle.BeforeLoadDFMValues;
  panFooter.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  gridView.BeforeLoadDFMValues;
  tmrFind.BeforeLoadDFMValues;
  dsOdvoz.BeforeLoadDFMValues;
  wdsOdvoz.BeforeLoadDFMValues;
  wdsOdvozOdvozCasOdvoza.BeforeLoadDFMValues;
  wdsOdvozPosodaOpis.BeforeLoadDFMValues;
  wdsOdvozKolicina.BeforeLoadDFMValues;
  try
    Name := 'frmZgodovinaLokacija';
    Left := 0;
    Top := 0;
    Align := alClient;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblTitle.SetParentComponent(Self);
    lblTitle.Name := 'lblTitle';
    lblTitle.Left := 0;
    lblTitle.Top := 0;
    lblTitle.Width := 831;
    lblTitle.Height := 79;
    lblTitle.Align := alTop;
    lblTitle.AutoSize := False;
    lblTitle.Caption := 'Odvozi za lokacijo';
    lblTitle.Color := clBtnFace;
    lblTitle.ElementClassName := 'display-2';
    lblTitle.ElementFont := efCSS;
    lblTitle.Font.Charset := DEFAULT_CHARSET;
    lblTitle.Font.Color := clWindowText;
    lblTitle.Font.Height := -21;
    lblTitle.Font.Name := 'Tahoma';
    lblTitle.Font.Style := [];
    lblTitle.HeightStyle := ssAuto;
    lblTitle.HeightPercent := 100.000000000000000000;
    lblTitle.Layout := tlCenter;
    lblTitle.ParentFont := False;
    lblTitle.WidthPercent := 100.000000000000000000;
    panFooter.SetParentComponent(Self);
    panFooter.Name := 'panFooter';
    panFooter.Left := 0;
    panFooter.Top := 706;
    panFooter.Width := 831;
    panFooter.Height := 120;
    panFooter.Align := alBottom;
    panFooter.BorderStyle := bsNone;
    panFooter.ChildOrder := 3;
    panFooter.Color := clWhite;
    panFooter.Padding.Top := 5;
    panFooter.TabOrder := 1;
    btnSelect.SetParentComponent(panFooter);
    btnSelect.Name := 'btnSelect';
    btnSelect.AlignWithMargins := True;
    btnSelect.Left := 656;
    btnSelect.Top := 10;
    btnSelect.Width := 165;
    btnSelect.Height := 107;
    btnSelect.Margins.Top := 5;
    btnSelect.Margins.Right := 10;
    btnSelect.Align := alRight;
    btnSelect.Caption := '<i class="material-icons" style="font-size:40px;">done</i>';
    btnSelect.ChildOrder := 1;
    btnSelect.ElementClassName := 'btn btn-xxl btn-success';
    btnSelect.ElementFont := efCSS;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    gridView.SetParentComponent(Self);
    gridView.Name := 'gridView';
    gridView.Left := 0;
    gridView.Top := 79;
    gridView.Width := 831;
    gridView.Height := 627;
    gridView.Align := alClient;
    gridView.Color := clWhite;
    gridView.Columns.Clear;
    with gridView.Columns.Add do
    begin
      DataField := 'Odvoz.CasOdvoza';
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'text-wrap';
      DataField := 'Posoda.Opis';
      Title := 'Stranka';
      Width := 340;
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'text-wrap';
      DataField := 'Kolicina';
      Title := 'Lokacija';
      Width := 340;
    end;
    gridView.DataSource := dsOdvoz;
    gridView.ElementFont := efCSS;
    gridView.ElementClassName := 'fs-2';
    gridView.FixedFont.Charset := DEFAULT_CHARSET;
    gridView.FixedFont.Color := clWindowText;
    gridView.FixedFont.Height := -12;
    gridView.FixedFont.Name := 'Segoe UI';
    gridView.FixedFont.Style := [];
    gridView.FixedCols := 0;
    gridView.FixedRows := 0;
    gridView.Font.Charset := DEFAULT_CHARSET;
    gridView.Font.Color := clWindowText;
    gridView.Font.Height := -48;
    gridView.Font.Name := 'Tahoma';
    gridView.Font.Style := [];
    gridView.Options := [goHorzLine,goRowSelect];
    gridView.ParentFont := False;
    gridView.TabOrder := 0;
    gridView.HeightPercent := 100.000000000000000000;
    gridView.ShowIndicator := False;
    gridView.WidthPercent := 100.000000000000000000;
    gridView.ColWidths[0] := 64;
    gridView.ColWidths[1] := 340;
    gridView.ColWidths[2] := 340;
    tmrFind.SetParentComponent(Self);
    tmrFind.Name := 'tmrFind';
    tmrFind.Enabled := False;
    tmrFind.Interval := 500;
    SetEvent(tmrFind, Self, 'OnTimer', 'tmrFindTimer');
    tmrFind.Left := 92;
    tmrFind.Top := 320;
    dsOdvoz.SetParentComponent(Self);
    dsOdvoz.Name := 'dsOdvoz';
    dsOdvoz.DataSet := wdsOdvoz;
    dsOdvoz.Left := 96;
    dsOdvoz.Top := 264;
    wdsOdvoz.SetParentComponent(Self);
    wdsOdvoz.Name := 'wdsOdvoz';
    wdsOdvoz.EntitySetName := 'OdvozPodrobno';
    wdsOdvoz.Connection := modMain.connServer;
    wdsOdvoz.SubpropsDepth := 2;
    wdsOdvoz.Left := 96;
    wdsOdvoz.Top := 208;
    wdsOdvozOdvozCasOdvoza.SetParentComponent(wdsOdvoz);
    wdsOdvozOdvozCasOdvoza.Name := 'wdsOdvozOdvozCasOdvoza';
    wdsOdvozOdvozCasOdvoza.FieldName := 'Odvoz.CasOdvoza';
    wdsOdvozOdvozCasOdvoza.DisplayFormat := 'dd.mm.yyyy hh:nn';
    wdsOdvozPosodaOpis.SetParentComponent(wdsOdvoz);
    wdsOdvozPosodaOpis.Name := 'wdsOdvozPosodaOpis';
    wdsOdvozPosodaOpis.FieldName := 'Posoda.Opis';
    wdsOdvozPosodaOpis.Size := 200;
    wdsOdvozKolicina.SetParentComponent(wdsOdvoz);
    wdsOdvozKolicina.Name := 'wdsOdvozKolicina';
    wdsOdvozKolicina.FieldName := 'Kolicina';
  finally
    lblTitle.AfterLoadDFMValues;
    panFooter.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    gridView.AfterLoadDFMValues;
    tmrFind.AfterLoadDFMValues;
    dsOdvoz.AfterLoadDFMValues;
    wdsOdvoz.AfterLoadDFMValues;
    wdsOdvozOdvozCasOdvoza.AfterLoadDFMValues;
    wdsOdvozPosodaOpis.AfterLoadDFMValues;
    wdsOdvozKolicina.AfterLoadDFMValues;
  end;
end;

end.